<mat-toolbar class="mainNavbar">
  <div
    class="mainNavbar_item mainNavbar_item--logoWrapper"
    [routerLink]="['/']"
  >
    <svg
      class="mainNavbar-logoImg"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 603 93"
    >
      <g>
        <path class="fillColor" d="M340.5,0h4.3v93.4h-4.3V0z" />
        <path class="fillColor" d="M0,17.3h8v51.1h19.2v8H0V17.3z" />
        <path
          class="fillColor"
          d="M102.6,17.4h8.1v36.3c0,5.4,1.3,9.5,3.9,12.5c2.6,2.9,6.2,4.4,11,4.4c4.7,0,8.3-1.3,11-4
              c2.7-2.7,4-6.5,3.9-11.4V17.4h8.1v37.2c0,7.2-2.1,13-6.2,17.3c-4.1,4.3-9.6,6.5-16.5,6.5c-7,0-12.6-2.2-16.9-6.6
              s-6.3-10.9-6.3-19.4L102.6,17.4z"
        />
        <path
          class="fillColor"
          d="M161.9,17.3H198v8.1h-14.1v51h-8v-51h-14V17.3z"
        />
        <path
          class="fillColor"
          d="M211.8,17.3h32.8v8.1h-24.8v14.8h24.8v8h-24.8v20.3h24.8v8h-32.8V17.3z"
        />
        <path
          class="fillColor"
          d="M307,19.4v9.1c-6.4-3.1-12.2-4.7-17.6-4.7c-6.4-0.2-12.7,2.2-17.4,6.6c-4.6,4.2-7.2,10.1-7.1,16.3
              c-0.1,6.3,2.5,12.3,7.2,16.5c4.8,4.4,10.8,6.6,18.1,6.6c5.3,0,10.8-1.7,16.7-5v9.2c-5.4,2.8-11.3,4.3-17.4,4.3
              c-8.8,0.2-17.2-3.2-23.5-9.3c-6.3-5.7-9.8-13.9-9.7-22.4c-0.1-8.4,3.4-16.4,9.6-22c6.2-6,14.5-9.3,23.1-9.2
              C295.3,15.5,301.3,16.9,307,19.4z"
        />
        <polygon
          class="fillColor"
          points="65.9,15 61.7,24.3 65.9,33.5 65.9,33.5 75.4,54.6 48.1,54.6 45.1,61.3 53.4,61.3 78.5,61.3
              85.3,76.4 93.8,76.4 	"
        />
        <path
          class="fillColor"
          d="M439.8,46.4c-0.1-8.4,3.4-16.3,9.6-21.9c6.2-6,14.6-9.3,23.2-9.1c8.5-0.1,16.7,3.2,22.8,9.2c6.4,6.1,9.6,13.4,9.6,21.9
              c0.2,8.5-3.3,16.8-9.5,22.6c-12.9,12.4-33.3,12.3-46.2-0.1C443.2,63.1,439.7,55,439.8,46.4z M496.4,46.8c0.1-6.2-2.5-12.2-7-16.5
              c-4.7-4.5-10.9-6.9-17.4-6.7c-6.3-0.1-12.3,2.4-16.8,6.8c-4.5,4.2-7.1,10.2-7,16.4c-0.1,6.2,2.5,12.2,7.2,16.4
              c4.8,4.5,11.1,6.9,17.6,6.7c6.2,0.1,12.2-2.4,16.5-6.8C494,58.8,496.5,53,496.4,46.8L496.4,46.8z"
        />
        <path
          class="fillColor"
          d="M519.8,17.3h12.8c6.4,0,11.6,1.6,15.6,4.8c3.8,2.9,6.1,7.4,6,12.2c0,3.9-1.3,7.6-3.9,10.5c-2.6,3-6.6,5.2-12.1,6.4
              l17.2,25.3H546l-16.4-24.3h-1.8v24.3h-8.1L519.8,17.3z M527.8,24.4V45c11.9,0.2,17.9-3.2,17.9-10.4c0.1-2.2-0.7-4.4-2.1-6.1
              c-1.5-1.6-3.4-2.8-5.6-3.2C534.7,24.6,531.3,24.4,527.8,24.4z"
        />
        <path
          class="fillColor"
          d="M387.9,69c6.3,6.1,14.7,9.5,23.5,9.3c6.1,0,12-1.4,17.4-4.3v-9.2c-5.9,3.3-11.4,5-16.7,5c-7.2,0-13.3-2.2-18.1-6.6
              c-3.6-3.2-6-7.5-6.9-12.3h-8.7C379.4,57.9,382.7,64.3,387.9,69z"
        />
        <path
          class="fillColor"
          d="M411.2,23.7c5.3,0,11.2,1.6,17.6,4.7v-9.1c-5.7-2.5-11.8-3.8-18-3.9c-8.6-0.2-16.9,3.2-23.1,9.2
              c-5.2,4.8-8.5,11.2-9.4,18.2h8.7c0.8-4.8,3.1-9.2,6.7-12.4C398.5,26,404.8,23.6,411.2,23.7z"
        />
        <polygon
          class="fillColor"
          points="568.4,76.4 601.1,76.4 601.1,68.4 576.3,68.4 576.3,56.2 568.4,56.2 	"
        />
        <polygon
          class="fillColor"
          points="601.1,25.4 601.1,17.3 568.4,17.3 568.4,48.1 601.1,48.1 601.1,40.1 576.3,40.1 576.3,25.4 	"
        />
      </g>
    </svg>
  </div>

  <div class="mainNavbar_item mainNavbar_item--rightSide">
    @if (selectedAccount(); as selectedAccount) {
      <div class="modulePicker" [matMenuTriggerFor]="modulesMenu">
        <button
          id="modulePickerButton"
          mat-button
          title="Module picker"
          data-cy="module-picker-button"
        >
          <mat-icon svgIcon="apps" class="icon--large" />
        </button>

        <mat-menu
          #modulesMenu="matMenu"
          class="m-2 modulePickerMatMenu"
          xPosition="before"
        >
          <ng-template matMenuContent>
            @if (modules().length > 0) {
              <div class="modules">
                @for (module of modulesWithAccess(); track module.id) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    [attr.data-cy]="`${module.name}-menu-option`"
                    (click)="navigateToModule(module)"
                  >
                    <div class="moduleDetails">
                      <img
                        [src]="module.favIconUrl"
                        [alt]="module.name || 'Module icon'"
                      />
                      <div>
                        <span>{{ module.name }}</span>
                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="activeModule">
                      <mat-icon svgIcon="check" />
                      <span>Active</span>
                    </div>
                  </div>
                }

                <div
                  class="modules_item"
                  mat-menu-item
                  (click)="navigateToModule(CORE_MODULE)"
                >
                  <div class="moduleDetails">
                    <img
                      [src]="CORE_MODULE.favIconUrl"
                      [alt]="CORE_MODULE.name || 'Core Module Fav icon'"
                    />
                    <div>
                      <span>{{ CORE_MODULE.name }}</span>
                      <div class="text-muted">
                        <span>{{ CORE_MODULE.description }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="activeModule">
                    <mat-icon svgIcon="check" />
                    <span>Active</span>
                  </div>
                </div>

                @for (module of modulesWithoutAccess(); track module.id) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    (click)="navigateToModule(module)"
                  >
                    <div class="moduleDetails">
                      <img
                        [src]="module.favIconUrl"
                        [alt]="module.name || 'Module icon'"
                      />
                      <div>
                        <span>{{ module.name }}</span>
                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="noAccessModule">
                      <span>Find out more</span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="text-muted p-3">
                <i>No apps available</i>
              </div>
            }
          </ng-template>
        </mat-menu>
      </div>

      <div class="userProfile">
        <button mat-button class="text-initial" [matMenuTriggerFor]="menu">
          <app-account-signature
            [account]="selectedAccount"
            [onlyAvatar]="true"
            [displayTooltip]="false"
          />
          <div class="d-flex align-items-center">
            <div class="userProfile_info d-flex flex-column text-start ms-2">
              <span class="text-start text-truncate">
                {{ selectedAccount.firstName }} {{ selectedAccount.lastName }}
              </span>
              <span class="text-small text-muted text-truncate">{{
                selectedAccount.client?.name
              }}</span>
            </div>

            <mat-icon class="iconRight" svgIcon="menu-down" />
          </div>
        </button>

        <mat-menu #menu="matMenu" xPosition="before" class="m-2">
          <div class="userProfile_accountSection">
            <app-account-signature [account]="selectedAccount" />

            <div class="userProfile_accountName">
              {{ selectedAccount.firstName }} {{ selectedAccount.lastName }}
            </div>
            <div class="text-small text-muted">{{ user()?.email }}</div>

            <a [routerLink]="['my-profile']"><span>My Account</span></a>
          </div>

          @if (!isSystemAdmin()) {
            <div class="clientPicker">
              @for (
                account of user()?.accounts ?? []
                  | sort: 'client.name' : 'asc' : true;
                track account.id
              ) {
                <button
                  mat-menu-item
                  class="clientPicker_item"
                  [class.selectedClient]="account.id === selectedAccount.id"
                  [class.cursor-default]="account.id === selectedAccount.id"
                  [class.cursor-pointer]="account.id !== selectedAccount.id"
                  (click)="
                    account.id !== selectedAccount.id && selectAccount(account)
                  "
                >
                  <div class="d-flex w-100 align-items-center text-truncate">
                    <div class="text-truncate">
                      <div class="text-truncate" [title]="account.client?.name">
                        {{ account.client?.name }}
                      </div>

                      @if (account.id === selectedAccount.id) {
                        <div class="text-small text-muted">Active session</div>
                      }
                    </div>

                    @if (account.client?.logoUrl) {
                      <img
                        class="clientPicker_logo ms-auto ps-1"
                        [alt]="account.client?.name ?? ''"
                        [src]="account.client?.logoUrl"
                      />
                    } @else {
                      <span class="ms-auto">&nbsp;</span>
                    }
                  </div>
                </button>
              }
            </div>
          }

          <button
            mat-menu-item
            class="userProfile_signOutBtn me-3 h-100"
            (click)="signOut()"
          >
            <mat-icon color="primary" svgIcon="logout" />
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    } @else {
      <button
        mat-button
        class="userProfile_signOutBtn me-3 h-100"
        (click)="signOut()"
      >
        <mat-icon color="primary" svgIcon="logout" />
        <span>Sign out</span>
      </button>
    }
  </div>
</mat-toolbar>
